import { t } from 'i18next'
import React, { useCallback, useEffect, useState } from 'react'
import { SelectOption } from '../../../../types/generalTypes'
import { Select } from 'antd'
import { useDataSources, useWorkspaceDetails } from '../../../../hooks'

interface CompensationMatrixAnalysisSelectSsrProps {
  value?: string
  onChange?: (value: string) => void
}

const CompensationMatrixAnalysisSelectSsr = ({
  value,
  onChange,
}: CompensationMatrixAnalysisSelectSsrProps) => {
  const { getDataSourceFiles } = useDataSources({ preventFetch: true })
  const { selectedWorkspace } = useWorkspaceDetails({ preventFetch: true })
  const [loading, setLoading] = useState(false)
  const [selectOptions, setSelectOptions] = useState<SelectOption[]>([])
  const [selectedValue, setSelectedValue] = useState<string | undefined>()

  const fetchDocuments = useCallback(async () => {
    const dataSourceId = selectedWorkspace?.dataSource.id
    if (!dataSourceId) return

    setLoading(true)

    try {
      const files = await getDataSourceFiles({ dataSourceId, format: 'docx' })
      if (files) {
        const options: SelectOption[] = files.map((file: any) => ({
          label: file.path,
          value: file.id,
        }))
        setSelectOptions(options)
      }
    } catch (err) {
      console.error('Error fetching documents:', err)
    } finally {
      setLoading(false)
    }
  }, [getDataSourceFiles, selectedWorkspace])

  useEffect(() => {
    fetchDocuments()
  }, [fetchDocuments])

  useEffect(() => {
    if (value) {
      setSelectedValue(value)
    }
  }, [value])

  return (
    <Select
      value={selectedValue}
      placeholder={t(
        'compensationMatrixAnalysisConfigurationModal.selectSsrPlaceholder'
      )}
      onChange={onChange}
      options={selectOptions}
      loading={loading}
    />
  )
}

export default CompensationMatrixAnalysisSelectSsr
